import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { MessageCircle, X } from 'lucide-react';

const FloatingWhatsApp = () => {
  const { language } = useLanguage();
  const [isExpanded, setIsExpanded] = useState(false);
  
  // WhatsApp number (remove spaces and special characters except +)
  const phoneNumber = '16478745620'; // Format: country code + number (no + or spaces)
  
  const content = {
    en: {
      chat: "Chat with us",
      message: "Hello! I'm interested in learning English at Canada English Life Academy.",
      tooltip: "Need help? Chat with us!"
    },
    ar: {
      chat: "تحدث معنا",
      message: "مرحباً! أنا مهتم بتعلم اللغة الإنجليزية في أكاديمية Canada English Life.",
      tooltip: "تحتاج مساعدة؟ تحدث معنا!"
    }
  };

  const t = content[language];

  // WhatsApp URL with pre-filled message
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(t.message)}`;

  return (
    <>
      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-8 left-8 z-50">
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="group relative"
          onMouseEnter={() => setIsExpanded(true)}
          onMouseLeave={() => setIsExpanded(false)}
        >
          {/* Tooltip on hover */}
          {isExpanded && (
            <div className={`absolute bottom-full mb-3 ${language === 'ar' ? 'right-0' : 'left-0'} whitespace-nowrap bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium shadow-lg animate-fade-in`}>
              {t.tooltip}
              <div className={`absolute top-full ${language === 'ar' ? 'right-6' : 'left-6'} w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-gray-900`}></div>
            </div>
          )}

          {/* Main WhatsApp Button */}
          <div className="relative flex items-center bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 group-hover:pr-6 overflow-hidden">
            {/* Icon */}
            <div className="w-14 h-14 flex items-center justify-center flex-shrink-0">
              <MessageCircle className="w-7 h-7 fill-white" />
            </div>
            
            {/* Expandable text */}
            <div className={`overflow-hidden transition-all duration-300 ${isExpanded ? 'max-w-xs opacity-100 pr-4' : 'max-w-0 opacity-0'}`}>
              <span className="font-bold text-lg whitespace-nowrap">{t.chat}</span>
            </div>
          </div>
        </a>
      </div>

      {/* Mobile: Show phone number at bottom */}
      <div className="fixed bottom-24 left-8 z-40 hidden max-sm:block">
        <a
          href={`tel:+${phoneNumber}`}
          className="text-xs text-gray-600 bg-white px-3 py-1 rounded-full shadow-md hover:shadow-lg transition-all"
        >
          +1 647 874 5620
        </a>
      </div>
    </>
  );
};

export default FloatingWhatsApp;
